const additionalServiceTypes = {
    lockSystemAdditionalUser: {}
};

Object.keys(additionalServiceTypes).forEach(key => {
    additionalServiceTypes[key].key = key;
});

export default additionalServiceTypes;
